import {faBarsSort} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Button, Dropdown, Radio} from 'antd';
import {useState} from 'react';

import {Locale} from '../../../../provider/locale/locale';
import {getReviewSortOptionLabelKey, REVIEW_SORT_OPTIONS} from '../../../../service/reviews/reviews-sort-helper';
import {ReviewSortingTypeEnum} from '../../../../service/reviews/reviews-type';
import {classNames} from '../../../../util/css';

import * as styles from './reviews-header-sort-button.scss';

type PropsType = {
    currentSort: ReviewSortingTypeEnum;
    isDesktop: boolean;
    onSortChange: (sort: ReviewSortingTypeEnum) => void;
};

export function ReviewsHeaderSortButton(props: PropsType): JSX.Element {
    const {currentSort, isDesktop, onSortChange} = props;
    const [isOpen, setIsOpen] = useState<boolean>(false);

    function handleSortChange(value: ReviewSortingTypeEnum) {
        onSortChange(value);
        setIsOpen(false);
    }

    function renderPopup(): JSX.Element {
        return (
            <div className={styles.ReviewsHeaderSortButton_popup}>
                <Radio.Group
                    className={styles.ReviewsHeaderSortButton_radioGroup}
                    onChange={(event) => handleSortChange(event.target.value as ReviewSortingTypeEnum)}
                    value={currentSort}
                >
                    {REVIEW_SORT_OPTIONS.map((sortOption) => (
                        <Radio
                            className={styles.ReviewsHeaderSortButton_radioOption}
                            key={sortOption}
                            value={sortOption}
                        >
                            <Locale stringKey={getReviewSortOptionLabelKey(sortOption)} />
                        </Radio>
                    ))}
                </Radio.Group>
            </div>
        );
    }

    return (
        <Dropdown
            dropdownRender={renderPopup}
            getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
            onOpenChange={setIsOpen}
            open={isOpen}
            trigger={['click']}
        >
            <Button
                className={classNames(
                    styles.ReviewsHeaderSortButton_trigger,
                    !isDesktop ? styles.ReviewsHeaderSortButton_trigger_iconOnly : ''
                )}
                icon={<FontAwesomeIcon icon={faBarsSort} />}
                type="default"
            >
                {isDesktop && <Locale stringKey={getReviewSortOptionLabelKey(currentSort)} />}
            </Button>
        </Dropdown>
    );
}
